import { Col, Menu, Row, Space } from "antd";
import type { MenuProps } from "antd";
import { BarsOutlined, BranchesOutlined, ExclamationCircleOutlined, GlobalOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router";
import { IResourceDetails } from "../../types";

export default function ResourceSettingsRoot() {
    const navigate = useNavigate();
    const location = useLocation();
    const { resourceDetails } = useOutletContext<{ resourceDetails: IResourceDetails }>();
    const [activeTab, setActiveTab] = useState("general");

    useEffect(() => {
        setActiveTab(location.pathname.split("/")[8] || "general");
    }, [location.pathname]);

    const getMenuItems = () => {
        let items: MenuProps["items"] = [{
            key: "general",
            label: <Space>
                <BarsOutlined />
                General
            </Space>
        }];

        if (!resourceDetails.isPublic) {
            items.push({
                key: "git",
                label: <Space>
                    <BranchesOutlined />
                    Git
                </Space>
            })
        }

        if (resourceDetails.domain.eligibleForDomainConfiguration) {
            items.push({
                key: "domain",
                label: <Space>
                    <GlobalOutlined />
                    Domain
                </Space>
            })
        }

        items.push({
            key: "danger-zone",
            label: <Space>
                <ExclamationCircleOutlined />
                Danger Zone
            </Space>,
            danger: true
        })

        return items;
    }

    return (
        <Row gutter={24}>
            <Col span={6}>
                <Menu
                    mode="inline"
                    className="ant-card-bordered"
                    selectedKeys={[activeTab]}
                    onSelect={(item) => {
                        navigate(item.key);
                        setActiveTab(item.key);
                    }}
                    items={getMenuItems()}
                />
            </Col>
            <Col span={18}>
                <Outlet context={{ resourceDetails }} />
            </Col>
        </Row >
    )
}